import SVGInject from "@iconfu/svg-inject";

const getSvgColorMode = (svg: SVGSVGElement) => {
  const colorableElements = svg.querySelectorAll<SVGElement>('path, circle, ellipse, line, polyline, polygon, rect');

  const hasStroke = Array.from(colorableElements).some((element) => {
    const stroke = element.getAttribute('stroke') ?? element.style.stroke;
    return Boolean(stroke && stroke !== 'none');
  });

  return hasStroke ? 'stroke-current' : 'fill-current';
};

const resetSvgColors = (svg: SVGSVGElement, mode: 'fill-current' | 'stroke-current') => {
  const colorAttribute = mode === 'stroke-current' ? 'stroke' : 'fill';

  svg.classList.remove('fill-current', 'stroke-current');
  svg.classList.add(mode);

  svg.querySelectorAll<SVGElement>('path, circle, ellipse, line, polyline, polygon, rect').forEach((element) => {
    element.removeAttribute(colorAttribute);
    element.style.removeProperty(colorAttribute);
  });
};

const initInjectableSvg = () => {
  SVGInject(document.querySelectorAll('img.injectable'), {
    afterInject: (_img, svg) => {
      resetSvgColors(svg, getSvgColorMode(svg));
    }
  });
};

export default initInjectableSvg;